import { render, staticRenderFns } from "./VPIChart.vue?vue&type=template&id=43cbfd3e"
import script from "./VPIChart.vue?vue&type=script&lang=ts"
export * from "./VPIChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports